var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('managerment',[_c('main-view',{scopedSlots:_vm._u([{key:"menu",fn:function(){return [_c('ui-menu-bar',{attrs:{"controller":_vm.menu_controller},on:{"collapse":_vm.changeCollapse,"changeComponent":_vm.changeTeamComponent}})]},proxy:true},{key:"body",fn:function(){return [(
          _vm.currentGroup === 'AccountRecharge' &&
          _vm.$session.permissions.any('RECHARGE_COIN', 'SHOW_ALL_MENUS')
        )?_c('account-recharge'):_vm._e(),(
          _vm.currentGroup === 'InviteMain' &&
          (_vm.$session.type === 'account' ||
            _vm.$session.permissions.any('SHOW_ALL_MENUS'))
        )?_c('invite-gift'):_vm._e(),(
          _vm.currentGroup === 'CoinLogs' &&
          (_vm.$session.type === 'account' ||
            _vm.$session.permissions.any('COIN_DETAIL', 'SHOW_ALL_MENUS'))
        )?_c('coin-logs'):_vm._e(),(_vm.currentGroup === 'FlowDetail')?_c('flow-manager'):_vm._e(),(
          _vm.currentGroup === 'OrderManage' &&
          _vm.$session.permissions.any('VIEW_ORDER_DETAIL', 'SHOW_ALL_MENUS')
        )?_c('order-manage'):_vm._e(),(
          _vm.currentGroup === 'InvoiceManage' &&
          (_vm.$session.type === 'account' ||
            _vm.$session.permissions.any('INVOICE_MANAGEMENT', 'SHOW_ALL_MENUS'))
        )?_c('invoice-manage'):_vm._e()]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }